import styled from 'styled-components'
import { theme } from '../../../../../style/theme'

export const ButtonsModalWrapper = styled.div`
	font-size: 1rem;

	&.desk-cols-2 {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 0 0.63em;
	}

	@media screen and (max-width: ${theme.point820}) {
		&.desk-cols-2 {
			grid-template-columns: 1fr;
			gap: 0;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		&.mobile-indent {
			margin-bottom: 5em;
		}
	}
`
ButtonsModalWrapper.displayName = 'ButtonsModalWrapper'

export const InputReasonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.63em;
	padding-bottom: .67em;
`
InputReasonWrapper.displayName = 'InputReasonWrapper'
